import { IErrorResult, IResult } from '../../models/result-models';
import { IUserModel } from '../../models/user-model';
// tslint:disable-next-line: max-line-length
import {
    CREATE_USER_ERROR,
    CREATE_USER_SUCCESS,
    DELETE_USER_ERROR,
    DELETE_USER_SUCCESS,
    LOAD_USER_SUCCESS,
    UPDATE_USER_ERROR,
    UPDATE_USER_SUCCESS,
    ACTION_USER_FATAL,
} from './user-actions';

interface ILoadUserSuccess {
    type: 'LOAD_USER_SUCCESS';
    payload: IResult<IUserModel>;
}

interface ICreateUserSuccess {
    type: 'CREATE_USER_SUCCESS';
    payload: IResult<IUserModel>;
}

interface ICreateUserError {
    type: 'CREATE_USER_ERROR';
    payload: IErrorResult;
}

interface IUpdateUserSuccess {
    type: 'UPDATE_USER_SUCCESS';
    payload: IResult<IUserModel>;
}

interface IUpdateUserError {
    type: 'UPDATE_USER_ERROR';
    payload: IErrorResult;
}

interface IDeleteUserSuccess {
    type: 'DELETE_USER_SUCCESS';
    payload: IResult<IUserModel>;
}

interface IDeleteUserError {
    type: 'DELETE_USER_ERROR';
    payload: IErrorResult;
}

interface IActionUserFatal {
    type: 'ACTION_USER_FATAL';
    payload: IErrorResult;
}

const initialSate = {
    ok: false,
};

type KnownAction =
    | ILoadUserSuccess
    | ICreateUserSuccess
    | ICreateUserError
    | IUpdateUserSuccess
    | IUpdateUserError
    | IDeleteUserSuccess
    | IDeleteUserError
    | IActionUserFatal;

export const userReducer = (
    state: IResult<IUserModel> = initialSate,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_USER_SUCCESS:
        case CREATE_USER_SUCCESS:
        case UPDATE_USER_SUCCESS:
            return action.payload;
        case CREATE_USER_ERROR:
        case UPDATE_USER_ERROR:
        case DELETE_USER_ERROR:
            return {
                ok: false,
                data: state.data,
                errors: action.payload.modelErrors,
                message: action.payload.errorMessage,
            };
        case DELETE_USER_SUCCESS:
            return { ok: true, data: null };
        case ACTION_USER_FATAL:
            return {
                ok: false,
                data: state.data,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};
